<template>
    <el-dialog
        v-model="dialogShow"
        :title="book==null?'新建课程包':'编辑课程包'"
        width="600px" 
        align-center="true"
        :before-close="handleClose"
        destroy-on-close
        >
        
        <div class="inrect vh-flex">
            <div class="dialog_lb">课程包名称</div>
            <div class="mgt10">
                <input type="text" v-model="bookName" class="dialog_input" placeholder="请输入课程包名称" />
            </div>
            <div class="vh-full"></div>
            <SaveButton @buttonClick="saveClick"></SaveButton>
        </div>
    </el-dialog>
  </template>
  
  <script>
  import SaveButton from '@/components/SaveButton.vue'
  import httpClient from '@/commom/http/httpClient'
  export default {
    name: 'NewBookDialog',
    components:{
        SaveButton
    },
    props: {
      show:Boolean,
      book:Object
    },
    watch:{
        show:function(nval,old){
            this.dialogShow = nval
            if(nval){
                if(this.book){
                    this.bookName = this.book.bookName
                }
            }
        },
        
    },
    data(){
        return {
            dialogShow:this.showDialog,
            bookName:""
        }
    },
    methods:{
        handleClose:function(){
          this.selectButton(false)
        },
        ///选择按钮
        selectButton:function(result,data){
            var res = {
                confrim:result,
                data:data
            }
            this.$emit("selectButton",res)
        },
        saveClick:function(result){
            if(!result){
                this.selectButton(false)
                return
            }
            if(this.book==null){
                this.saveNewBook()
            }else{
                this.saveEditBook()
            }
        },
        ///保存更新
        saveEditBook:function(){
            var bookName = this.bookName.trim()
            if(bookName.length==0){
                this.$message({message: '请输入课程包名称'})
                return
            }
            var model = {
                BookName:bookName
            }
            var req = {
                bookId:this.book.bookId,
                model:JSON.stringify(model)
            }
            var that = this
            httpClient.invoke("UserBookAPI.UpdateBook",req,function(res){
                if(res.error){
                    that.$message({message: res.error})
                    return
                }
                if(!res.success){
                    that.$message({message: res.message})
                    return
                }
                
                that.selectButton(true,model)
            })
        },
        saveNewBook:function(){
            var bookName = this.bookName.trim()
            if(bookName.length==0){
                this.$message({message: '请输入课程包名称'})
                return
            }
            var model = {
                BookName:bookName,
                Language:"en",
                PlayerName:"",
                ReviewType:"",
                GroupId:"",
                IconInfo:"",
                BookType:"sentence"
            }
            var req = {
                model:JSON.stringify(model)
            }
            var that = this
            httpClient.invoke("UserBookAPI.CreateBook",req,function(res){
                if(res.error){
                    that.$message({message: res.error})
                    return
                }
                if(!res.success){
                    that.$message({message: res.message})
                    return
                }
                
                that.selectButton(true,model)
            })
        }
       
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    .inrect{
        height: 500px;
        padding-top:20px;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 15px;
    }
  </style>
  